import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import theme from '@/styles/theme';

interface SolidButtonProps {
  type: 'PRIMARY' | 'BLUE' | 'RED' | 'GREEN' | 'YELLOW' | 'WHITE' | 'DEFAULT';
  onClick: any;
  children: string | Element;
  style?: CSSProperties;
}

interface StyledComponentProps extends HTMLButtonElement {
  colorType:
    | 'PRIMARY'
    | 'BLUE'
    | 'RED'
    | 'GREEN'
    | 'YELLOW'
    | 'WHITE'
    | 'DEFAULT';
}

type COLOR = {
  [key: string]: string;
};

const BACKGROUND_COLOR: COLOR = {
  PRIMARY: theme.DF_COLOR.PRIMARY500,
  BLUE: theme.DF_COLOR.BLUE500,
  RED: theme.DF_COLOR.RED500,
  GREEN: theme.DF_COLOR.GREEN500,
  YELLOW: theme.DF_COLOR.YELLOW500,
  DEFAULT: theme.DF_COLOR.GRAY100,
  WHITE: theme.DF_COLOR.WHITE
};

const HOVER_COLOR: COLOR = {
  PRIMARY: theme.DF_COLOR.PRIMARY700,
  BLUE: theme.DF_COLOR.BLUE700,
  RED: theme.DF_COLOR.RED700,
  GREEN: theme.DF_COLOR.GREEN700,
  YELLOW: theme.DF_COLOR.YELLOW700,
  DEFAULT: theme.DF_COLOR.GRAY200,
  WHITE: theme.DF_COLOR.GRAY100
};

const SolidButton = (props: SolidButtonProps) => {
  const { type, onClick, ...rest } = props;
  return (
    <SolidButtonWrapper colorType={type} onClick={onClick} {...rest}>
      <span>{props.children}</span>
    </SolidButtonWrapper>
  );
};

export default SolidButton;

const SolidButtonWrapper = styled.button<StyledComponentProps & any>`
  ${theme.DF_TYPOGRAPHY.UI18B};
  background: ${({ colorType }) => BACKGROUND_COLOR[colorType]};
  border: 0;
  box-shadow: none;
  color: ${({ colorType }) =>
    colorType === 'WHITE' ? theme.DF_COLOR.GRAY800 : theme.DF_COLOR.WHITE};
  padding: 8px 16px;
  min-width: 160px;
  height: 52px;
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
  transition: background 0.4s;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      background: ${({ colorType }) => BACKGROUND_COLOR[colorType]};
    }
  }

  &:hover {
    background: ${({ colorType }) => HOVER_COLOR[colorType]};
  }
`;
